import { useEffect, useState } from 'react';
import NewsSliderRows from '../components/news/NewsSliderRows';

export default function TrailerPage() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetch('/api/news/content')
      .then((response) => { if (!response.ok) throw new Error('News request failed'); return response.json(); })
      .then((data) => { if (active) setNews(data.data || []); })
      .catch((error) => { console.error(error); if (active) setNews([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const nigeriaNews = news.filter((item) => item.category === 'nigeria' || item.category === 'africa');
  const gamingNews = news.filter((item) => item.category === 'gaming');

  return <div className="min-h-screen overflow-x-hidden bg-[#181720]">
    <div className="flex min-h-[260px] items-center justify-center bg-cover bg-center p-6 text-white md:min-h-[320px] lg:min-h-[380px]" style={{ backgroundImage: "url('/assets/banner-about-bg.webp')" }}>
      <div className="w-full max-w-6xl text-center md:text-left">
        <h1 className="text-4xl font-bold md:text-5xl lg:text-6xl">News</h1>
        <div className="mt-4 flex justify-center gap-2 text-sm text-gray-300 md:justify-start"><span>Home</span><span>›</span><span>Pages</span><span>›</span><span className="font-semibold text-yellow-400">News</span></div>
      </div>
    </div>
    <section className="bg-[#0a0a0f] px-6 py-16"><NewsSliderRows title="Nigeria News" items={nigeriaNews} loading={loading} /></section>
    <section className="bg-[#181720] px-6 py-16 pb-32"><NewsSliderRows title="Gaming News" items={gamingNews} loading={loading} /></section>
  </div>;
}
